<template>
  <!--    添加资讯-->
  <el-dialog title="添加资讯" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
             @close="$emit('update:visible',false)" top="7vh">
    <el-form :model="editFrom">
      <el-form-item label="资讯标题" :label-width="formLabelWidth">
        <el-input v-model="editFrom.title" auto-complete="off" placeholder="资讯标题"></el-input>
      </el-form-item>
      <el-form-item label="封面图片" :label-width="formLabelWidth">
        <uploadImg @getChildValue="getChildValue" imgNumber="1" page="appletDesignInfomation"
                   :picSrc="editFrom.pic"></uploadImg>
      </el-form-item>
      <el-form-item label="详情内容" :label-width="formLabelWidth">
        <!-- bidirectional data binding（双向数据绑定） -->
        <quill-editor
                class="quill-editor alleditorHeight"
                v-model="editFrom.content"
                ref="myQuillEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
        >
          <div id="toolbar" slot="toolbar"> <!-- Add a bold button -->
            <button class="ql-bold" title="加粗">Bold</button>
            <button class="ql-italic" title="斜体">Italic</button>
            <button class="ql-underline" title="下划线">underline</button>
            <button class="ql-strike" title="删除线">strike</button>
            <button class="ql-blockquote" title="引用"></button>
            <button class="ql-code-block" title="代码"></button>
            <button class="ql-header" value="1" title="标题1"></button>
            <button class="ql-header" value="2" title="标题2"></button> <!--Add list -->
            <button class="ql-list" value="ordered" title="有序列表"></button>
            <button class="ql-list" value="bullet" title="无序列表"></button> <!-- Add font size dropdown --> <select
                    class="ql-header" title="段落格式">
              <option selected>段落</option>
              <option value="1">标题1</option>
              <option value="2">标题2</option>
              <option value="3">标题3</option>
              <option value="4">标题4</option>
              <option value="5">标题5</option>
              <option value="6">标题6</option>
            </select> <select class="ql-size" title="字体大小">
              <option value="10px">10px</option>
              <option value="12px">12px</option>
              <option value="14px">14px</option>
              <option value="16px" selected>16px</option>
              <option value="18px">18px</option>
              <option value="20px">20px</option>
            </select>
            <select class="ql-font" title="字体">
              <option value="SimSun">宋体</option>
              <option value="SimHei">黑体</option>
              <option value="Microsoft-YaHei">微软雅黑</option>
              <option value="KaiTi">楷体</option>
              <option value="FangSong">仿宋</option>
              <option value="Arial">Arial</option>
            </select>
            <!-- Add subscript and superscript buttons -->
            <select class="ql-color" value="color" title="字体颜色"></select>
            <select class="ql-background" value="background" title="背景颜色"></select>
            <select class="ql-align" value="align" title="对齐"></select>
            <button class="ql-clean" title="还原"></button>
            <button class="ql-image" title="插入图片"></button>
            <button class="ql-video" title="插入视频"></button>
            <button class="ql-undo" title="撤销" @click="undo"><i class="iconfont iconchexiao"></i></button>
            <button class="ql-redo" title="重做" @click="redo"><i class="iconfont iconredo"></i></button>
            <!--<button class="ql-clear" title="清空" @click="clearContent"></button>-->
          </div>
        </quill-editor>
      </el-form-item>
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="saveHtml" size="small">{{!this.infomation?'确认添加':'保存编辑'}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
  import {quillEditor} from 'vue-quill-editor'
  import Quill from 'quill' //引入编辑器
  import {ImageDrop} from 'quill-image-drop-module';
  import uploadImg from "@/components/dialog/uploadImg.vue";
  import { handlers } from "@/assets/js/quill-config";
  Quill.register('modules/imageDrop', ImageDrop);
  import Video from "@/assets/js/quill-video";
  import api from "@/api.js";
  Quill.register(Video, true);
  export default {
    name: "addOrgDialog",
    props: ["visible", "infomation"],
    watch: {
      visible() {
        this.dialogFormVisible = this.visible;
        if (this.visible) {
          if (this.infomation) {
            this.editFrom = {
              title: this.infomation.title,// 资讯标题
              pic: this.infomation.pic, // 资讯pic
              content: this.infomation.content, // 资讯内容
              info_id: this.infomation.id
            }
          } else {
            this.editFrom = {
              title: '',// 资讯标题
              pic: '', // 资讯pic
              content: '<p>资讯详情内容</p>' // 资讯内容
            }
          }
        }else{
          this.editFrom = {
            title: '',// 资讯标题
            pic: '', // 资讯pic
            content: '<p>资讯详情内容</p>' // 资讯内容
          }
        }
      }
    },
    components: {
      uploadImg
    },
    data() {
      return {
        formLabelWidth: '80px',
        dialogFormVisible: false,
        editorOption: {
          placeholder: "请输入内容",
          theme: "snow", // or 'bubble'
          history: {
            delay: 2000,
            maxStack: 50,
            userOnly: true
          },
          modules: {
            // imageDrop: true, // 图片推拽上传
            toolbar: {
              container: '#toolbar',
              handlers
            }
          },
          theme: 'snow'
        },
        editFrom: {
          title: '',// 资讯标题
          pic: '', // 资讯pic
          content: '<p>资讯详情内容</p>' // 资讯内容
        }
      };
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      }
    },
    created() {
      // console.log('页面参数', this.infomation)
    },
    methods: {
      undo() {
        this.$refs.myQuillEditor.quill.history.undo();
      },
      redo(){
        this.$refs.myQuillEditor.quill.history.redo();
      },
      getChildValue(option) {
        this.editFrom.pic = option
      },
      saveHtml() {
        if (!this.editFrom.title) {
          this.$message.error('请填写相应的资讯标题');
          return
        }
        if (!this.editFrom.pic) {
          this.$message.error('请上传相应的封面图片');
          return
        }
        if (!this.editFrom.content) {
          this.$message.error('请填写相应的资讯内容');
          return
        }
        // dialogBtn: 0 // 0添加 1编辑;
        let url_ = api.information_add;
        let data = this.editFrom;
        if (this.infomation) {
          url_ = api.information_edit;
        }
        this.axios
            .post(url_, data)
            .then(response => {
              if (response.data.code == 0) {
                this.axios
                    .post(api.information_index, {})
                    .then(response => {
                      if (response.data.code == 0) {
                        this.$emit('checkInt', response.data.list)
                        this.dialogFormVisible = false
                        this.editFrom = {
                          title: '',// 资讯标题
                          pic: '', // 资讯pic
                          content: '<p>公司详情内容</p>' // 资讯内容
                        }
                      }
                    })
                    .catch(response => {
                    });                
              } else {
              }
            })
            .catch(response => {
            });
      },
      onEditorBlur() {
      },
      onEditorFocus(quill) {
        // console.log("editor focus!", quill);
      },
      onEditorReady(quill) {
        // console.log("editor ready!", quill);
      },
      // 失去焦点事件
    }
  };
</script>

